import { apiClient } from '../apiClient';
import type { CatalogCategory } from '../../types/catalog';

interface CatalogParams {
  categoryId?: number;
  categorySlug?: string;
  subCategoryIds?: number[];
}

const buildCatalogQueryParams = (params?: CatalogParams) => {
  const queryParams = new URLSearchParams();

  if (typeof params?.categoryId === 'number') {
    queryParams.append('category_id', String(params.categoryId));
  }

  if (params?.categorySlug) {
    queryParams.append('category_slug', params.categorySlug);
  }

  params?.subCategoryIds?.forEach((subCategoryId) => {
    queryParams.append('sub_category_ids[]', String(subCategoryId));
  });

  return queryParams;
};

export interface CheckoutPayload {
  phone: string;
  delivery_address?: string;
  notes?: string;
  contact: string;
}

export const getCategories = async (activeOnly = true) => {
  const response = await apiClient.get<{ data: CatalogCategory[] }>('/categories', {
    params: {
      active_only: activeOnly,
    },
  });
  return response.data;
};

export const getCategoriesTree = async () => {
  const response = await apiClient.get<{ data: CatalogCategory[] }>(
    '/categories/tree',
  );
  return response.data;
};

export const getCatalog = async (params?: CatalogParams) => {
  const queryParams = buildCatalogQueryParams(params);
  const queryString = queryParams.toString();
  const response = await apiClient.get(
    queryString ? `/products?${queryString}` : '/products',
  );
  return response.data;
};

export const getCatalogItem = async (product_id: number) => {
  const response = await apiClient.get(`/products/${product_id}`);
  return response.data;
};

export const createOrder = async (payload: CheckoutPayload) => {
  const response = await apiClient.post('/cart/checkout', payload);
  return response.data;
};

export const getBanners = async () => {
  const response = await apiClient.get('/banners');
  return response.data;
};
